import Image from 'next/image';
import { useState, useCallback } from 'react';
import ReactPlayer from 'react-player/lazy';

import { Container, Section, Cards, Card, TranslateButton } from './styles';

import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';

interface IWebAppCases {
  id: number;
  content: string;
  type: string;
}

interface IProps {
  iconURL: string;
  cases: IWebAppCases[];
}

const PrincipaisCases: React.FC<IProps> = ({ iconURL, cases }) => {
  const [mainItem, setMainItem] = useState(1);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const getLoopItem = useCallback(
    (item: number) => {
      if (item === -2) return cases.length - 2;
      if (item === -1) return cases.length - 1;
      if (item === cases.length) return 0;
      if (item === cases.length + 1) return 1;

      return item;
    },
    [cases.length]
  );

  const keepMainItemLoop = useCallback(
    (item: number) => {
      return setMainItem(getLoopItem(item));
    },
    [getLoopItem]
  );

  const handleTouchStart = useCallback(
    (e: any) => {
      if (e?.targetTouches?.length) {
        setTouchStart(e?.targetTouches[0].clientX);
      }
    },
    [setTouchStart]
  );

  const handleTouchMove = useCallback(
    (e: any) => {
      if (e?.targetTouches?.length) {
        setTouchEnd(e?.targetTouches[0].clientX);
      }
    },
    [setTouchEnd]
  );

  const handleTouchEnd = useCallback(() => {
    if (!touchEnd || !touchStart) return;

    if (touchStart - touchEnd < -100) {
      keepMainItemLoop(mainItem - 1);
    }

    if (touchStart - touchEnd > 100) {
      keepMainItemLoop(mainItem + 1);
    }

    setTouchEnd(0);
    setTouchStart(0);
  }, [touchStart, touchEnd, keepMainItemLoop, mainItem]);

  if (!cases) return null;

  return (
    <Container>
      <Section>
        <img src={iconURL} alt="Icone" />
        <h2>Principais Cases</h2>

        <Cards>
          <TranslateButton
            className="previous"
            onClick={() => keepMainItemLoop(mainItem - 1)}
          >
            <RiArrowLeftSLine size={35} />
          </TranslateButton>

          {cases.map((item, index) => {
            const className = () => {
              switch (index) {
                case getLoopItem(mainItem):
                  return 'centro';
                case getLoopItem(mainItem - 1):
                  return 'esquerda';
                case getLoopItem(mainItem + 1):
                  return 'direita';
                case getLoopItem(mainItem - 2):
                  return 'hidden keep-left';
                case getLoopItem(mainItem + 2):
                  return 'hidden keep-right';
                default:
                  return 'hidden';
              }
            };

            return (
              <Card
                className={className()}
                key={item.id}
                onTouchStart={(touchStartEvent) =>
                  handleTouchStart(touchStartEvent)
                }
                onTouchMove={(touchMoveEvent) =>
                  handleTouchMove(touchMoveEvent)
                }
                onTouchEnd={() => handleTouchEnd()}
                onMouseDown={(mouseDownEvent) =>
                  handleTouchStart(mouseDownEvent)
                }
                onMouseMove={(mouseMoveEvent) =>
                  handleTouchMove(mouseMoveEvent)
                }
                onMouseLeave={() => handleTouchEnd()}
              >
                {item.type === 'image' && (
                  <Image
                    src={item.content}
                    alt="Imagem de demonstração"
                    height={760}
                    width={376}
                  />
                )}
                {item.type === 'gif' && (
                  <Image
                    src={item.content}
                    alt="Imagem de demonstração"
                    height={760}
                    width={376}
                  />
                )}
                {item.type === 'video' && (
                  <ReactPlayer
                    height={760}
                    width={376}
                    url={item.content}
                    controls={className() === 'centro'}
                  />
                )}
              </Card>
            );
          })}
          <TranslateButton
            className="next"
            onClick={() => keepMainItemLoop(mainItem + 1)}
          >
            <RiArrowRightSLine size={35} />
          </TranslateButton>
        </Cards>
      </Section>
    </Container>
  );
};

export default PrincipaisCases;
